import React from "react";

import { Checkbox } from "Components/atoms/Checkbox";
import { Image } from "Components/atoms/Image";
import { FilterElement } from "../FilterElement";

import { EntityFilterWrapper, EntityItem } from "./styles";
import { EntityFilterProps } from "./types";

/**
 * Componente EntityFilter
 *
 * Exibe uma lista de entidades (companhias aéreas, vendedores) para seleção com base em filtros.
 *
 * @param {EntityFilterItem[]} entities - Lista de entidades para exibição.
 * @param {string} title - Título do filtro.
 * @param {string} iconName - Nome do ícone associado ao filtro.
 * @param {(item: EntityFilterItem, isChecked: boolean) => void} onChange - Callback executado ao alterar a seleção de uma entidade.
 * @param {boolean} hasBorder - Define se o filtro deve ter uma borda inferior.
 */
export const EntityFilter: React.FC<EntityFilterProps> = ({
  entities,
  title,
  iconName,
  onChange,
  hasBorder = true,
  onToggleAll,
}) => {
  return (
    <EntityFilterWrapper>
      <FilterElement
        title={title}
        iconName={iconName}
        hasBorder={hasBorder}
        onToggleAll={entities.length ? onToggleAll : undefined}
      >
        {entities.map((entity, index) => (
          <EntityItem key={index}>
            <Checkbox
              name="entities"
              value={entity.id}
              isChecked={entity.isChecked}
              color="black"
              label={entity.name}
              onChange={(value) =>
                onChange(entity, value === entity.id && !entity.isChecked)
              }
            />
            {entity.logo && <Image src={entity.logo} alt={entity.name} />}
          </EntityItem>
        ))}
      </FilterElement>
    </EntityFilterWrapper>
  );
};
